import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted,computed,watch } from 'vue'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'slider',
  props: {
    num: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    precision: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["updataNum"],
  setup(__props, { emit: __emit }) {

  const props = __props;
  
  const bar = ref<HTMLElement | null>(null);
  const Pos = ref("left: 0;");
  const leftNum = ref(0);
  
  // 判断是否需要处理小数
  const needDecimal = computed(() => {
    // 检查props.min, props.max或props.num中是否有小数
    return Number.isInteger(props.min) === false || Number.isInteger(props.max) === false || Number.isInteger(props.num) === false;
  });
  
  watch(
    () => props.num,
    (newValue) => {
      if (!bar.value) return;
  
      if (newValue > props.max) {
        moveNum();
        return;
      } else if (newValue < props.min) {
        moveNum();
        return;
      }
  
      let w = bar.value.clientWidth;
      leftNum.value = ((newValue - props.min) / (props.max - props.min)) * w;
      Pos.value = `left: ${leftNum.value}px;`;
    }
  );
  
  // 初始化状态
  onMounted(() => {
    if (!bar.value) return;
  
    let w = bar.value.clientWidth;
    if (typeof props.num === "number" && typeof props.min === "number" && typeof props.max === "number") {
      leftNum.value = ((props.num - props.min) / (props.max - props.min)) * w;
      Pos.value = `left: ${leftNum.value}px;`;
    }
  });
  
  const emit = __emit;
  
  const moveNum = () => {
    if (!bar.value) return;
  
    let w = bar.value.clientWidth;
    const calculatedValue = props.min + (leftNum.value / w) * (props.max - props.min);
  
    // 根据是否需要小数处理结果
    if (props.precision) {
      // 处理小数情况，保留一位小数
      emit("updataNum", parseFloat(calculatedValue.toFixed(1)));
    } else {
      // 处理整数情况
      emit("updataNum", Math.round(calculatedValue));
    }
  };
  
  // 点击滑动条
  const barClick = (e: MouseEvent) => {
    if (!bar.value) return;
  
    // 防止点击到滑块本身时触发
    if (e.target !== bar.value && e.target !== bar.value.firstElementChild) return;
  
    // 获取点击位置
    let x = e.pageX - bar.value.getBoundingClientRect().left;
  
    // 判断是否超出范围
    if (x > bar.value.clientWidth) {
      x = bar.value.clientWidth;
    } else if (x < 0) {
      x = 0;
    }
  
    leftNum.value = x;
    Pos.value = `left: ${leftNum.value}px;`;
    moveNum();
  };
  
  // 点击后添加事件
  const mousedown = () => {
    window.addEventListener("mousemove", handleChange);
    window.addEventListener("mouseup", mouseup);
  };
  
  // 移动滑块
  const handleChange = (e: MouseEvent) => {
    if (!bar.value) return;
  
    // 获取滑块的宽度（可移动区域）
    let w = bar.value.clientWidth;
    // 获取鼠标的位置
    let x = e.pageX - bar.value?.getBoundingClientRect().left;
    // 判断是否超出范围
    if (x > w) {
      x = w;
    } else if (x < 0) {
      x = 0;
    }
  
    leftNum.value = x;
    Pos.value = `left: ${leftNum.value}px;`;
    moveNum();
  };
  
  // 鼠标放开后移除事件
  const mouseup = () => {
    document.ondragstart = function (ev) {
      ev.preventDefault();
    };
    document.ondragend = function (ev) {
      ev.preventDefault();
    };
    window.removeEventListener("mousemove", handleChange);
    window.removeEventListener("mouseup", mouseup);
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bar",
    ref_key: "bar",
    ref: bar,
    onClick: barClick
  }, [
    _createElementVNode("div", {
      class: "sliderBar",
      style: _normalizeStyle({ width: leftNum.value + 'px' })
    }, null, 4),
    _createElementVNode("div", {
      class: "slider",
      style: _normalizeStyle(Pos.value),
      onMousedown: mousedown
    }, null, 36)
  ], 512))
}
}

})